<template>
  <div>
    <div>
      <AppRouterLink
        :to="{ name: 'EventView', params: { id: value.id } }"
        class="group peer relative col-span-1 mb-2 flex aspect-default h-fit w-full items-center justify-center overflow-hidden rounded-xl bg-secondary"
      >
        <UiPicture
          v-for="image in 2"
          :key="'image' + image"
          :src="value.image"
          :alt="value.title"
          :options="{ height: 168 * 1.5 }"
          :img-classes="image > 1 ? 'object-cover' : ''"
          :class="
            image > 1
              ? 'absolute z-0 size-full object-cover opacity-20 blur-lg inset-center'
              : 'relative z-10 h-full max-h-full max-w-full object-contain transition ease-out group-hover:scale-105'
          "
          lazy
        >
          <template v-if="image < 2" #default-image>
            <UiBackupImage :value="value.title" :alt="value.title" />
          </template>
        </UiPicture>
      </AppRouterLink>
      <AppRouterLink
        :to="{ name: 'EventView', params: { id: value.id } }"
        class="group mb-2 block h-fit !px-2 !pt-1 text-left !text-text-main peer-hover:!text-button-link-primary-hover"
      >
        <UiTitle
          severity="h5"
          class="inline text-inherit group-hover:text-button-link-primary-hover"
        >
          {{ value.title }}
        </UiTitle>
      </AppRouterLink>
      <ul class="grid h-fit grid-cols-4 gap-2 pb-1 xxs:gap-1 md:gap-1 lg:gap-2">
        <li v-for="seance in seances" :key="seance.id">
          <UiCard
            :tag="seance.ticketsLeft ? AppRouterLink : 'button'"
            type="button"
            :to="{ name: 'SeanceView', params: { id: seance.id } }"
            class="flex w-full flex-col justify-center p-4 text-left"
            :class="{ 'bg-secondary !px-2': !seance.ticketsLeft }"
            :disabled="!seance.ticketsLeft"
          >
            <UiDate :value="seance.beginsAt" template="HH:mm" class="text-sm font-medium" />
            <p v-if="seance.ticketsLeft" class="text-xs text-text-secondary">
              {{ toRub(seance.priceRange.min) }}
            </p>
            <p v-else class="text-xxs text-text-secondary">распродано</p>
          </UiCard>
        </li>
        <li v-if="needMoreButton">
          <UiCard
            tag="UiButton"
            class="flex h-full flex-col justify-center p-4"
            @click="emit('showMore')"
          >
            <span class="font-medium">ещё</span>
          </UiCard>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { toRub } from '@/6_shared/lib'
import { UiPicture, UiTitle, UiDate, UiBackupImage, UiCard, AppRouterLink } from '@/6_shared/ui'
import type { Event } from '../../model'

type PropType = {
  value: Event
}
type EmitType = {
  (e: 'showMore'): void
}

const props = defineProps<PropType>()
const emit = defineEmits<EmitType>()

const MAX_SEANCES = 3
const seances = computed(() => props.value.seances.filter((_, index) => index < MAX_SEANCES))
const needMoreButton = computed(() => props.value.seances.length > seances.value.length)
</script>
